namespace $ { $mol_style_attach( "invite/dict/dict.view.css",
 "[invite_dict] {\n\tflex: 1;\n}\n\n[invite_dict_body] {\n\tjustify-content: center;\n\talign-items: center;\n}\n\n[invite_dict_word] {\n\talign-items: center;\n\tfont-size: 2rem;\n}\n"
) }